module.exports = __webpack_public_path__ + "img/payment_p.c92a87b4.png";